import React from 'react';
import Header from './Header';
import Footer from './Footer';

const PageLayout = ({ 
  children, 
  currentUser,
  onLoginClick,
  onLogout,
  onPricingClick,
  onNewAnalysis,
  onCompareMode,
  onNavigateTo,
  onNavigateHome,
  onShowBadges,
  onShowAgency,
  auditSoundEnabled,
  onAuditSoundChange,
  apiStatus,
  modals,
  noMainWrapper = false
}) => {
  return (
    <div className="cv-public min-h-screen theme-bg theme-text">
      <Header 
        currentUser={currentUser}
        onLoginClick={onLoginClick}
        onLogout={onLogout}
        onPricingClick={onPricingClick}
        onNewAnalysis={onNewAnalysis}
        onCompareMode={onCompareMode}
        onNavigateTo={onNavigateTo}
        onNavigateHome={onNavigateHome}
        onShowBadges={onShowBadges}
        onShowAgency={onShowAgency}
        auditSoundEnabled={auditSoundEnabled}
        onAuditSoundChange={onAuditSoundChange}
        showHeaderLogo={true}
      />
      {noMainWrapper ? (
        children
      ) : (
        <main className="pt-24 pb-16">
          {children}
        </main>
      )}
      <Footer 
        onPricingClick={onPricingClick} 
        onNavigateTo={onNavigateTo} 
        apiStatus={apiStatus} 
      />
      {modals}
    </div>
  );
};

export default PageLayout;
